import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class EstimatorsService {

    private estimatorsUrl: string = environment.apiUrl + '/contractors';
    private estimators: any;

    constructor(
        private http: HttpClient,
    ) {
        this.getEstimatorsFromServer()
            .subscribe(estimators => {
                this.estimators = estimators;
            });
            

    }

    private getEstimatorsFromServer() {
        
        return this.http.get<any>(this.estimatorsUrl);
    }
    getEstimators() {
        return this.http.get<any>(this.estimatorsUrl);

    }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/estimators.service.ts